export enum SupportedPOS {
  SQUARE = 'Square',
  UBEREATS = 'Ubereats',
}
